import { SegmentHeader } from "@/components/campaign/basic/SegmentHeader";
import { TriggerCards } from "@/components/campaign/TriggerCards";
import { AlertModal } from "@/components/generic/AlertModal";
import { Button } from "@/components/generic/Button";
import { PageHeaderProvider } from "@/providers/PageHeaderProvider";
import {
  createFileRoute,
  linkOptions,
  useBlocker,
} from "@tanstack/react-router";
import { useMemo } from "react";

export const Route = createFileRoute(
  "/_dashboard/campaigns/$id/(edit)/planning/triggers/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const context = Route.useRouteContext();
  const {
    updateCampaign,
    updateCampaignMutation: { isPending },
  } = context.useEditCampaign();
  const { triggers, isDirty, setTriggers } = context.useTriggers();

  const blocker = useBlocker({
    shouldBlockFn: ({ next }) => {
      if (!isDirty) return false;
      if (next.routeId.startsWith(Route.id)) return false;
      return true;
    },
    withResolver: true,
  });

  return (
    <PageHeaderProvider
      options={useMemo(
        () => ({
          actions: (
            <>
              <Button
                isDisabled={isPending || !isDirty}
                isPending={isPending}
                onPress={async () => {
                  await updateCampaign({
                    triggers,
                  });
                }}
              >
                Gem
              </Button>
            </>
          ),
        }),
        [isPending, isDirty, triggers, updateCampaign],
      )}
    >
      <div className="flex w-full flex-col gap-y-10">
        <SegmentHeader
          title="Salgstriggers"
          description="Vælg de salgstriggere der gør, at en virksomhed i din målgruppe bliver til et lead."
        />

        <TriggerCards
          triggers={triggers}
          buildTriggerLink={(triggerId) =>
            linkOptions({
              from: Route.fullPath,
              to: "/campaigns/$id/planning/triggers/$triggerId",
              params: { triggerId },
            })
          }
        />
      </div>
      <AlertModal
        isOpen={blocker.status === "blocked"}
        title="Du har ikke-gemte ændringer"
        description="Dine ændringer vil gå tabt. Er du sikker på at du vil fortsætte?"
        onClose={blocker.reset}
        onConfirm={() => {
          setTriggers(context.campaign.triggers);
          blocker.proceed?.();
        }}
      />
    </PageHeaderProvider>
  );
}
